var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFooterMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9994 6.2041H5.47884C4.3269 6.2041 3.39307 7.18255 3.39307 8.38953V21.5021C3.39307 22.7091 4.3269 23.6875 5.47884 23.6875H22.9994C24.1513 23.6875 25.0851 22.7091 25.0851 21.5021V8.38953C25.0851 7.18255 24.1513 6.2041 22.9994 6.2041Z",
    stroke: "white",
    strokeWidth: 1.3349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73035 9.70117L14.2391 15.8204L21.7479 9.70117",
    stroke: "white",
    strokeWidth: 1.3349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footer-mail.7e32f2d49ebee7431b674c8ddbccc955.svg";
export { ForwardRef as ReactComponent };